import { Component, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public usuario = null;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private svUtils: UtilsService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.getLoggedUser();
  }

  // openContactModal() {
  //   const dialogRef = this.dialog.open(ContactUsComponent, {
  //     width: '500px',
  //     autoFocus: false,
  //     restoreFocus: true,
  //     hasBackdrop: true,
  //   });
  // }

  // openTermsAndConditionsModal() {
  //   const dialogRef = this.dialog.open(TermsAndConditionsComponent, {
  //     width: '100%',
  //     height: '80%',
  //     autoFocus: false,
  //     restoreFocus: true,
  //     hasBackdrop: true,
  //   });
  // }
  getLoggedUser() {
    this.usuario = this.svUtils.getLoggedUser();
  }
}
